import Axios from 'axios';
import Config from '../Config';
import Store from '../redux/store';
import { setLoading } from '../modules/App/AppState';

const loadAxios = (url, options) => {
  Store.dispatch(setLoading(true));
  const promise = new Promise((resolve, reject) => {
    Axios.get(url, options).then(data => {
      Store.dispatch(setLoading(false));
      return resolve(data);
    }).catch(err => reject(err));
  });

  return promise;
};


export default {
  loadAppConfig: () => loadAxios(Config.APP_CONFIG_URL),
  loadProductConfig: params => loadAxios(Config.getProductConfig(params)),
  loadOverlayConfig: url => loadAxios(url),
  loadWarningsConfig: () => loadAxios(Config.APP_WARNINGS_URL, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }),
  loadRecommondationConfig: (productId) => {
    const url = Config.APP_RECOMMENDATION_URL.replace('%product', productId);
    return loadAxios(url);
  },
};



/** WEBPACK FOOTER **
 ** ./apps/maptool/services/ConfigApi.js
 **/